<template>
  <nav class="tl-nav">
    <div class="tl-nav__container">

      <!-- ── Left: Brand & Navigation ── -->
      <div class="tl-nav__section-left">
        <!-- Brand/Logo -->
        <router-link to="/" class="tl-nav__brand">
          <img src="@lib/frontend/assets/logo.png" alt="timechange" class="tl-nav__logo-img" />
        </router-link>

        <!-- Navigation Links -->
        <div class="tl-nav__menu" :class="{ 'is-open': isMenuOpen }">
          <ul class="tl-nav__list">
            <template v-if="profile?.role?.name === 'Berlin'">
              <li class="tl-nav__item">
                <router-link to="/oceancalender" class="tl-nav__link">Ocean Calendar</router-link>
              </li>
              <li class="tl-nav__item">
                <router-link to="/calculation/tourlist" class="tl-nav__link">Ocean Calculation</router-link>
              </li>
            </template>
            <template v-else-if="profile?.role?.name === 'Cologne'">
              <li class="tl-nav__item">
                <router-link to="/calender" class="tl-nav__link">River Calendar</router-link>
              </li>
              <li class="tl-nav__item">
                <router-link to="/calculation-river/tourlistriver" class="tl-nav__link">River Calculation</router-link>
              </li>
            </template>
            <template v-else-if="profile?.role?.name === 'London'">
              <li class="tl-nav__item">
                <router-link to="/calculation-london/tourlist" class="tl-nav__link">Ocean Calculation London</router-link>
              </li>
            </template>
            <template v-else-if="profile?.role?.name === 'LFO'">
              <li class="tl-nav__item">
                <router-link to="/LFO" class="tl-nav__link">Prize Wheel</router-link>
              </li>
            </template>
            <template v-else-if="profile?.role?.name === 'Authenticated'">
              <li class="tl-nav__item">
                <router-link to="/allotments" class="tl-nav__link">Allotments</router-link>
              </li>
              <li class="tl-nav__item">
                <router-link to="/oceancalender" class="tl-nav__link">Ocean Calendar</router-link>
              </li>
              <li class="tl-nav__item">
                <router-link to="/calculation/tourlist" class="tl-nav__link">Ocean Calculation</router-link>
              </li>
              <li class="tl-nav__item">
                <router-link to="/calender" class="tl-nav__link">River Calendar</router-link>
              </li>
              <li class="tl-nav__item">
                <router-link to="/calculation-river/tourlistriver" class="tl-nav__link">River Calculation</router-link>
              </li>
            </template>
            <template v-else>
              <li class="tl-nav__item">
                <router-link :to="{ name: 'login' }" class="tl-nav__link tl-nav__link--login">Login</router-link>
              </li>
            </template>
          </ul>
        </div>
      </div>

      <!-- ── Right: User Info & Actions ── -->
      <div class="tl-nav__section-right">
        <!-- User Data (Now on the right) -->
        <div v-if="profile" class="tl-nav__user-data">
          <div class="tl-user-text">
            <span class="tl-user-email">{{ profile.email }}</span>
            <span class="tl-user-role">{{ profile.role?.name }}</span>
          </div>
          <div class="tl-user-icon">
            {{ profile.email.charAt(0).toUpperCase() }}
          </div>
        </div>

        <!-- Logout Button -->
        <button v-if="profile" @click="logout" class="tl-nav__logout" title="Logout">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          <span class="tl-logout-text">Logout</span>
        </button>

        <!-- Mobile Toggle -->
        <button class="tl-nav__toggle" @click="isMenuOpen = !isMenuOpen" :class="{ 'is-active': isMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { inject, ref } from 'vue'

export default {
  name: "Header",
  setup() {
    const { profile, logout } = inject('user')
    const isMenuOpen = ref(false)
    return { profile, logout, isMenuOpen }
  },
}
</script>

<style scoped>
/* ────────────── Navigation ────────────── */
.tl-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  background: #0f172a;
  border-bottom: 1px solid #1e293b;
  z-index: 1000;
  display: flex;
  align-items: center;
  font-family: 'Inter', system-ui, sans-serif;
  color: #f8fafc;
}

.tl-nav__container {
  width: 100%;
  max-width: 100%;
  /* Use full width for corner-to-corner feel */
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* ── Section Left ── */
.tl-nav__section-left {
  display: flex;
  align-items: center;
  gap: 24px;
}

.tl-nav__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  flex-shrink: 0;
}

.tl-nav__logo-img {
  height: 38px;
  width: auto;
  display: block;
}

.tl-nav__list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 4px;
}

.tl-nav__link {
  padding: 8px 12px;
  text-decoration: none;
  color: #94a3b8;
  font-size: 0.85rem;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.2s;
  white-space: nowrap;
}

.tl-nav__link:hover {
  background: #1e293b;
  color: #f8fafc;
}

.tl-nav__link.router-link-active {
  background: rgba(226, 146, 61, 0.15);
  color: #E2923D;
}

/* ── Section Right ── */
.tl-nav__section-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.tl-nav__user-data {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: 20px;
  border-right: 1px solid #1e293b;
}

.tl-user-text {
  display: flex;
  flex-direction: column;
  text-align: right;
}

.tl-user-email {
  font-size: 0.75rem;
  font-weight: 600;
  color: #cbd5e1;
}

.tl-user-role {
  font-size: 0.65rem;
  color: #64748b;
  text-transform: uppercase;
  font-weight: 800;
  letter-spacing: 0.05em;
}

.tl-user-icon {
  width: 28px;
  height: 28px;
  background: #334155;
  color: #94a3b8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  border: 1px solid #475569;
}

.tl-nav__logout {
  background: transparent;
  color: #94a3b8;
  border: 1px solid #1e293b;
  padding: 6px 14px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.8rem;
  font-weight: 600;
}

.tl-nav__logout:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.2);
}

.tl-nav__logout svg {
  width: 16px;
  height: 16px;
}

/* ── Mobile ── */
.tl-nav__toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
}

.tl-nav__toggle span {
  width: 22px;
  height: 2px;
  background: #f8fafc;
}

@media (max-width: 1200px) {
  .tl-nav__toggle {
    display: flex;
  }

  .tl-nav__logout .tl-logout-text {
    display: none;
  }

  .tl-nav__user-data {
    display: none;
  }

  /* Hide complex user data on small screens */

  .tl-nav__menu {
    position: fixed;
    top: 64px;
    left: 0;
    width: 100%;
    height: calc(100vh - 64px);
    background: #0f172a;
    flex-direction: column;
    padding: 32px;
    transform: translateX(100%);
    transition: transform 0.3s ease;
  }

  .tl-nav__menu.is-open {
    transform: translateX(0);
  }

  .tl-nav__list {
    flex-direction: column;
    width: 100%;
  }

  .tl-nav__link {
    display: block;
    font-size: 1.1rem;
    padding: 12px 0;
    border-bottom: 1px solid #1e293b;
  }
}
</style>